// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"964":"a3219725","994":"d2badc92"}[chunkId] + ".chunk.js";
};